import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Overlay full-screen con backdrop blur, logo Fina centrado con pulse + halo animado y
// un mensaje configurable. Pensado para usarse mientras un dashboard carga su data.
// Controlado por el padre via [visible].
@Component({
    selector: 'fina-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingOverlayComponent {
    @Input() visible = false;
    @Input() message = 'La herramienta de los emprendedores';
    @Input() logoSrc = 'assets/icons/logo.svg';
    /** Cantidad de blur del backdrop (CSS length). Default 8px. */
    @Input() blurAmount = '8px';
    /**
     * Si está en true, el blur se aplica `position: absolute` (cubre solo el ancestro
     * `position: relative` más cercano — útil para scope al módulo Estadísticas sin tapar
     * sidebar/header). Además renderiza un click-shield invisible `position: fixed` que
     * bloquea interacción con sidebar/header para evitar navegaciones durante la carga.
     * Si está en false (default), el overlay es `position: fixed` cubriendo todo el viewport.
     */
    @Input() contained = false;
}
